import { inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import VisuallyHidden from '../VisuallyHidden/VisuallyHidden.js';
import omit from 'lodash/fp/omit';
import { createPortal } from 'react-dom';

var Announce = /*#__PURE__*/function (_Component) {
  _inherits(Announce, _Component);

  function Announce(props) {
    var _this;

    _classCallCheck(this, Announce);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Announce).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "startTimeout", function () {
      clearTimeout(_this.timeout);
      _this.timeout = setTimeout(function () {
        _this.setState({
          renderChildren: false
        });
      }, 2000);
    });

    if (typeof window !== 'undefined') {
      _this.root = _this.props.getApplicationNode();
      _this.el = document.createElement('div');
    }

    if (_this.props.children) {
      _this.startTimeout();
    }

    _this.state = {
      renderChildren: _this.props.children ? true : false,
      latch: false,
      children: ''
    };
    return _this;
  }

  _createClass(Announce, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.root.appendChild(this.el);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.children && this.props.children !== prevProps.children) {
        this.startTimeout();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.root.removeChild(this.el);
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      if (typeof window === 'undefined') {
        return null;
      }

      var _this$state = this.state,
          renderChildren = _this$state.renderChildren,
          latch = _this$state.latch,
          children = _this$state.children;
      var rest = omit(['children', 'getApplicationNode'], this.props);
      return createPortal(React.createElement(React.Fragment, null, React.createElement(VisuallyHidden, _extends({
        component: "div",
        "aria-live": "assertive"
      }, rest), latch && renderChildren && children), React.createElement(VisuallyHidden, _extends({
        component: "div",
        "aria-live": "assertive"
      }, rest), !latch && renderChildren && children)), this.el);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.children && props.children !== state.children) {
        return {
          children: props.children,
          latch: !state.latch,
          renderChildren: true
        };
      }

      return null;
    }
  }]);

  return Announce;
}(Component);

_defineProperty(Announce, "defaultProps", {
  getApplicationNode: function getApplicationNode() {
    return document.body;
  }
});

Announce.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.string,
  getApplicationNode: PropTypes.func
} : {};
export default Announce;